import React from 'react'
import { connect } from 'dva'
import { checkAuthorization } from '../../Models/Authorize/checkAuthorization'

const Authorize: React.FC<any> = ({
  org = '',
  reqPermissions,
  forbiddenComponent = null,
  policyLogicalOperator = 'and',
  children,
  ...props
}) => {
  const present = checkAuthorization(org, reqPermissions, policyLogicalOperator)

  return present ? children : forbiddenComponent
}

export default connect(({ flowLayout, flows }: { flowLayout: any; flows: any }) => ({
  flowLayout,
  flows,
}))(Authorize)
